// extracted by mini-css-extract-plugin
export default {"mobileNav":"Navigation-Navigation-module__mobileNav--teLHk","desktopNav":"Navigation-Navigation-module__desktopNav--B5ibp"};